import { SiteLink } from 'interfaces/site-link.interface';
import { SeoLinkRelEnum } from 'modules/seo-module/interfaces/seo-link-rel.enum';
import { LinkTarget } from 'atomic/link/link-target.enum';

export const items = [
    {
        label: 'Dla użytkownika',
        items: [
            {
                label: 'Skąpiec radzi',
                href: 'https://www.skapiec.pl/radzi',
                title: 'Skąpiec radzi'
            },
            {
                label: 'Zasady sortowania',
                href: '/zasady-sortowania',
                title: 'Zasady sortowania',
                rel: SeoLinkRelEnum.NOFOLLOW
            },
            {
                label: 'Najczęściej zadawane pytania',
                href: '/site/doc/4',
                title: 'Najczęściej zadawane pytania',
                rel: SeoLinkRelEnum.NOFOLLOW
            },
            {
                label: 'Jak to działa?',
                href: '/site/doc/3',
                title: 'Jak to działa?',
                rel: SeoLinkRelEnum.NOFOLLOW
            },
            {
                label: 'Twoje zgody',
                href: 'https://polityka-prywatnosci.onet.pl/',
                target: LinkTarget.BLANK,
                title: 'Twoje zgody w serwisie skapiec.pl',
                rel: SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER
            },
            {
                label: 'Regulamin',
                href: '/regulamin',
                title: 'Regulamin użytkownika',
                rel: SeoLinkRelEnum.NOFOLLOW
            },
            {
                label: 'Newsletter',
                href: '/newsletter',
                title: 'Zapisz się na newsletter już dziś!',
                rel: SeoLinkRelEnum.NOFOLLOW
            },
            {
                label: 'Zgloś kwestię prawną',
                href: '/report-notice/index.html',
                title: 'Zgloś kwestię prawną',
                rel: SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER,
                icon: 'mail',
                weight: '600',
                target: LinkTarget.BLANK
            }
        ]
    },
    {
        label: 'Dla sklepów',
        items: [
            {
                label: 'Dołącz do Skąpiec.pl',
                href: 'https://panel.onetads.pl/wizard/skapiec',
                target: LinkTarget.BLANK,
                title: 'Chcesz zwiększyć sprzedaż?',
                rel: SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER
            },
            {
                label: 'Raport Sklepów 2023',
                href: 'https://ranking.opineo.pl/?utm_source=stopka&utm_medium=skapiec.pl',
                target: LinkTarget.BLANK,
                title: 'Ranking Sklepów Internetowych 2022 - Najlepsze sklepy w Opineo.pl',
                rel: SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER
            }
        ]
    },
    {
        label: 'Dla partnerów',
        items: [
            {
                label: 'Program Partnerski',
                href: 'https://panel.moneteasy.pl/login',
                target: LinkTarget.BLANK,
                title: 'Informacje ogólne',
                rel: SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER
            },
            {
                label: 'FAQ - Program Partnerski',
                href: 'https://moneteasy.pl/wydawca#faq',
                target: LinkTarget.BLANK,
                title: 'Pytania i odpowiedzi',
                rel: SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER
            },
            {
                label: 'API Skąpiec',
                href: '/site/doc/400',
                title: 'API Skąpiec.pl',
                rel: SeoLinkRelEnum.NOFOLLOW
            },
            {
                label: 'Regulamin',
                href: '/regulamin-programu-partnerskiego',
                title: 'REGULAMIN DLA PARTNERÓW PROGRAMU PARTNERSKIEGO MONETEASY22',
                target: LinkTarget.BLANK,
                rel: SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER
            }
        ]
    },
    {
        label: 'Skąpiec.pl',
        items: [
            {
                label: 'O nas',
                href: '/o-nas',
                title: 'O nas',
                rel: SeoLinkRelEnum.NOFOLLOW
            },
            {
                label: 'Centrum prasowe',
                href: '/site/doc/200',
                target: LinkTarget.BLANK,
                title: 'Komunikaty prasowe',
                rel: SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER
            },
            {
                label: 'Kariera',
                href: 'https://www.ringieraxelspringer.pl/kariera/oferty-pracy',
                target: LinkTarget.BLANK,
                title: 'Pracuj w Ringier Axel Springer',
                rel: SeoLinkRelEnum.NOFOLLOW_NOOPENER_NOREFERRER
            },
            {
                label: 'Kontakt',
                href: '/kontakt',
                title: 'Kontakt',
                rel: SeoLinkRelEnum.NOFOLLOW
            },
            {
                label: 'Akt o usługach cyfrowych',
                href: '/akt-uslugi-cyfrowe',
                title: 'Akt o usługach cyfrowych',
                rel: SeoLinkRelEnum.NOFOLLOW
            }
        ]
    }
] as {
    label: string;
    items: SiteLink[];
}[];

export const media = [
    {
        label: 'Facebook',
        href: 'https://www.facebook.com/Skapiec',
        title: 'Facebook',
        rel: SeoLinkRelEnum.NOOPENER_NOREFERRER,
        icon: 'facebook-filled'
    },
    {
        label: 'Instagram',
        href: 'https://www.instagram.com/skapiec_pl/',
        title: 'Instagram',
        rel: SeoLinkRelEnum.NOOPENER_NOREFERRER,
        icon: 'instagram'
    }
] as {
    label: string;
    href: string;
    title: string;
    rel: string;
    icon: string;
}[];
